import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page404Container } from './containers';
import { AppContainerUiModule } from '@purplefront/app-container/ui';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    AppContainerUiModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [Page404Container],
  exports: [Page404Container]
})
export class AppContainerFeatureShellModule {}
